



















import Vue, { PropType } from 'vue'
import XIcon, { IconProps } from '@/components/atoms/Icon/XIcon.vue'

export type ButtonProps = {
  loading?: boolean
  disabled?: boolean
  active?: boolean
  outlined?: boolean
  text?: boolean
  icon?: IconProps
  variant?: ButtonVariant
  size?: ButtonSize
}

type ButtonVariant =
  | 'primary'
  | 'secondary'
  | 'success'
  | 'warning'
  | 'important'
  | 'info'
  | 'light'
  | 'dark'
  | 'link'

type ButtonSize = 'default' | 'small' | 'medium' | 'large'

export default Vue.extend({
  inheritAttrs: false,
  name: 'XButton',
  components: { XIcon },
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    active: {
      type: Boolean,
      default: false,
    },
    outlined: {
      type: Boolean,
      default: false,
    },
    text: {
      type: Boolean,
      default: false,
    },
    icon: {
      type: Object as PropType<IconProps>,
      required: false,
    },
    variant: {
      type: String as PropType<ButtonVariant>,
      default: 'primary',
    },
    size: {
      type: String as PropType<ButtonSize>,
      default: 'default',
    },
  },
  methods: {
    handleClick(event: UIEvent) {
      if (this.disabled) {
        event.preventDefault()
        event.stopPropagation()
        return
      }
      this.$emit('click', event)
    },
  },
})
